import React, { useState } from 'react';
import {
    IconButton,
    Typography,
    Button,
    Paper,
    Grid
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { smallScreenWidth } from '../constants/AppConstants';
import OpenSearchDropdown from '../components/OpenSearchDropdown'
import fetchFromAthena from '../functions/FetchFromAthena'
import LoadingButton from '../components/LoadingButton'
import ReactTable from '../components/ReactTable';

import { useGarnishmentCols } from '../hooks/EmployeeCols';

const defaultHeaders = {
    company: null,
    employee: null
}

export default function Garnishment(props) {
    const { credentials } = props.fetchInitialData
    const [data, setData] = useState(null)
    const [headers, setHeaders] = useState(defaultHeaders)
    const [clearHeader, setClearHeader] = useState(false)
    const [clearTrigger, setClearTrigger] = useState(false)
    const [isLoading, setLoading] = React.useState(false)
    const [company, setCompany] = useState('')
    const [employee, setEmployee] = useState('')
    const garnishmentCols = useGarnishmentCols();

    const handleSubmit = async () => {
        if (!headers.employee || !headers.company) {
            props.createSnack('Company and Employee are required', 'warning', 3000)
            return
        }
        setLoading(true)

        const data = await fetchFromAthena({
            queryName: 'garnishment',
            headers: {
                company: headers.company,
                employee: headers.employee
            },
            accessToken: credentials.user.accessToken,
            credentials: credentials
        }).then(results => {
            return results
        })
        setData(data)
        setLoading(false)
    }

    return (
        <div style={{ padding: '1.5rem 0.5rem' }}>
            <IconButton
                style={{ borderRadius: '5px', position: 'absolute' }}
                size="small"
                onClick={() => props.history.push('/')}
                aria-label="delete"
            >
                <ArrowBackIcon />
                {props.fetchInitialData.credentials.appWidth > smallScreenWidth && 'Dashboard'}
            </IconButton>
            <Typography variant="h5" style={{ textAlign: 'center' }}>
            Garnishment (PR26)
            </Typography>

            <div style={{ margin: '1rem' }}>
                <Paper
                    elevation={0}
                    style={{ marginTop: '2rem', width: '100%', padding: '1rem' }}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} style={{ position: 'relative' }}>
                            <div style={{ margin: '0 1rem 0 0' }}>
                                <Grid
                                    container
                                    alignContent='center'
                                    alignItems='flex-start'
                                    spacing={3}
                                >
                                    <Grid item>
                                        <OpenSearchDropdown
                                            id='company'
                                            required
                                            width='250px'
                                            label='Company'
                                            page="EMPLOYEE"
                                            entity="COMPANY"
                                            searchFields={['DISPLAY']}
                                            accessToken={credentials.user.accessToken}
                                            credentials={credentials}
                                            clearTrigger={clearTrigger}
                                            onChange={(val) => {
                                                const companyValue = val?.VALUE || null
                                                setCompany(companyValue || '')
                                                setHeaders({ ...headers, company: companyValue })
                                            }}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <OpenSearchDropdown
                                            key={`employee-${company}`}
                                            id='employee'
                                            required
                                            disabled={!company}
                                            width='300px'
                                            label='Employee'
                                            page="EMPLOYEE"
                                            entity="EMPLOYEE"
                                            searchFields={['DISPLAY']}
                                            accessToken={credentials.user.accessToken}
                                            credentials={credentials}
                                            clearTrigger={clearTrigger}
                                            filters={{
                                                COMPANY: company
                                            }}
                                            onChange={(val) => {
                                                const employeeValue = val?.VALUE || null
                                                setEmployee(employeeValue || '')
                                                setHeaders({ ...headers, employee: employeeValue })
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </div>

                        </Grid>
                        <div style={{ marginTop: '1rem' }}>
                            <LoadingButton
                                disabled={!headers.company || !headers.employee}
                                label='Submit'
                                isLoading={isLoading}
                                color='primaryVLButton'
                                fn={() => handleSubmit(headers.employee)}
                            />
                            {!!(headers.company || headers.employee) && (
                                <Button
                                    onClick={() => {
                                        setClearHeader(!clearHeader)
                                        setHeaders(defaultHeaders)
                                        setCompany('')
                                        setEmployee('')
                                        setClearTrigger(prev => !prev)
                                    }}
                                    style={{ marginLeft: '0.5rem' }}
                                >
                                    Clear
                                </Button>
                            )}
                        </div>
                    </Grid>
                </Paper>
                {!!data && (
                    <div style={{ marginTop: '1rem' }}>
                        <ReactTable isLoading={isLoading} cols={garnishmentCols} data={data} />
                    </div>
                )}

            </div>
        </div>
    );
}
